import * as angular from 'angular';

import { PlannedGraduationDropdownModule } from './../../../../shared/components/planned-graduation-dropdown/planned-graduation-dropdown.module';
import { CreditGapTransferStepperModule } from './credit-gaps-transfer-stepper/credit-gaps-transfer-stepper.module';
import { CreditGapTransferTableModule } from './credit-gaps-transfer-table/credit-gaps-transfer-table.module';
import { CreditGapsTransferWizardComponent } from './credit-gaps-transfer-wizard.component';

export const CreditGapsTransferWizardModule = angular
  .module('creditGapsTransferWizardModule', [
    PlannedGraduationDropdownModule,
    CreditGapTransferStepperModule,
    CreditGapTransferTableModule,
  ])
  .component('creditGapsTransferWizard', CreditGapsTransferWizardComponent).name;
